import { render } from "./MaterialAlmacenForm.vue?vue&type=template&id=8cc4f1ee&scoped=true"
import script from "./MaterialAlmacenForm.vue?vue&type=script&lang=js"
export * from "./MaterialAlmacenForm.vue?vue&type=script&lang=js"

import "./MaterialAlmacenForm.vue?vue&type=style&index=0&id=8cc4f1ee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cc4f1ee"]])

export default __exports__